import { render, staticRenderFns } from "./HeaderV2.vue?vue&type=template&id=1e21e21c&"
import script from "./HeaderV2.vue?vue&type=script&lang=js&"
export * from "./HeaderV2.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports